export var StepState = /*#__PURE__*/ function(StepState) {
    StepState["Disabled"] = "disabled";
    StepState["Selected"] = "selected";
    StepState["Enabled"] = "enabled";
    return StepState;
}({});
export const INDICATOR_HEIGHT = 32;
export const getStepState = (step, currentStep, visitedSteps)=>{
    if (step === currentStep) return "selected";
    if (visitedSteps.includes(step)) return "enabled";
    return "disabled";
};
export const calculateIndicatorPosition = (element, indicatorHeight)=>({
        top: element.offsetTop + (element.offsetHeight - indicatorHeight) / 2,
        height: indicatorHeight
    });
